/**
 * GET BOOKING_CANCEL_INFO Action
 */

import {
  ACTION_GET_BOOKING_CANCEL_INFO,
  ACTION_GET_BOOKING_CANCEL_INFO_SUCCESS,
  ACTION_GET_BOOKING_CANCEL_INFO_FAILURE,
  ACTION_EMPTY_BOOKING_CANCEL_INFO,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';
import { Dispatch } from 'redux';

export function getCancelInfo(bookingId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `bookings/cancel-info/${bookingId}`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
        },
      },
    });

    return null;
  };
}

export function emptyCancelInfoResults() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_BOOKING_CANCEL_INFO,
      payload: null,
    });
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_BOOKING_CANCEL_INFO,
    payload: null,
  };
}

export function requestSuccess(responseJSON: any) {
  return {
    type: ACTION_GET_BOOKING_CANCEL_INFO_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: any) {
  return {
    type: ACTION_GET_BOOKING_CANCEL_INFO_FAILURE,
    payload: responseJSON,
  };
}
